<template>
    <div id="page_space_before_prep_edit" class="sbp-edit">
        <div class="sbp-edit-main-layout">
            <header class="sbp-edit-project-name-bar">
                <span class="sbp-edit-project-name-icon" aria-hidden="true">
                    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.65">
                        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                        <path d="M14 2v6h6" />
                        <path d="M8 13h8M8 17h8" />
                    </svg>
                </span>
                <h1 class="sbp-edit-project-name-title">{{ currentProject.name || '当前项目' }}</h1>
            </header>

            <div class="sbp-edit-panel">
                <div class="sbp-edit-panel-header">
                    <div class="sbp-edit-panel-header-main">
                        <div class="sbp-edit-panel-title">🛡️ 行前准备模块管理</div>
                    </div>
                    <el-button v-if="!isView" type="primary" size="small" icon="el-icon-plus" @click="openAddModuleDialog">新增模块</el-button>
                </div>

                <div v-loading="detailLoading" class="sbp-edit-panel-body">
                    <p class="sbp-edit-hint">💡 管理员可自定义模块名称、图标和上传对应文件。学生端将按此处配置的模块和文件展示内容。</p>

                    <div class="sbp-edit-form-group sbp-edit-prep-name-field">
                        <label for="prep-display-name">行前准备名称 <span class="sbp-edit-required">*</span></label>
                        <input id="prep-display-name" v-model.trim="prepDisplayName" type="text" class="sbp-edit-form-input"
                            placeholder="例如：2026春季研学 · 行前准备" :readonly="isView" :disabled="isView">
                    </div>

                    <div v-if="!modules.length" class="sbp-edit-empty">
                        <div class="sbp-edit-empty-icon">📂</div>
                        <p class="sbp-edit-empty-text">暂无模块，请点击「新增模块」添加</p>
                    </div>

                    <div v-for="mod in modules" :key="mod.id" class="sbp-edit-module-card">
                        <div class="sbp-edit-module-card-header">
                            <div class="sbp-edit-module-card-icon" :style="{ background: iconBg(mod.icon) }">{{ mod.icon }}</div>
                            <div class="sbp-edit-module-card-title">
                                <input v-model.trim="mod.name" type="text" class="sbp-edit-module-name-input" :readonly="isView"
                                    :disabled="isView">
                            </div>
                            <div v-if="!isView" class="sbp-edit-module-card-actions">
                                <!-- <button type="button" class="sbp-edit-btn sbp-edit-btn-default sbp-edit-btn-xs" @click="toggleEditName(mod)">编辑</button> -->
                                <button type="button" class="sbp-edit-btn sbp-edit-btn-danger sbp-edit-btn-xs" @click="deleteModule(mod)">删除</button>
                            </div>
                        </div>
                        <div class="sbp-edit-module-card-body">
                            <span>已上传 <b>{{ (mod.files && mod.files.length) || 0 }}</b> 个文件</span>
                        </div>
                        <div class="sbp-edit-module-upload sbp-edit-upload-zone">
                            <upload :ref="'moduleUpload' + mod.id" :key="'upload-module-' + mod.id" zone @uploadFile="onModuleUploadFile"
                                @fileUploaded="onModuleFileUploaded" @fileDelete="onModuleFileDelete" :name="'module_' + mod.id"
                                text="📁 点击上传文件或拖拽到此处" AdjustTheType="ReviewManagement" :is-disabled="isView"
                                :list="mod.uploadList || []" />
                        </div>
                    </div>
                </div>

                <div v-if="!isView" class="sbp-edit-panel-footer">
                    <button type="button" class="sbp-edit-btn sbp-edit-btn-primary" :disabled="saveAllLoading" @click="saveAll">
                        {{ saveAllLoading ? '保存中...' : '💾 保存所有配置' }}
                    </button>
                    <el-button class="sbp-edit-back-btn" @click="goList">返回列表</el-button>
                </div>
                <div v-else class="sbp-edit-panel-footer">
                    <el-button type="primary" plain @click="goList">返回列表</el-button>
                </div>
            </div>
        </div>

        <el-dialog title="➕ 新增模块" :visible.sync="addModuleVisible" width="560px" append-to-body destroy-on-close
            @closed="resetAddModuleForm">
            <div class="sbp-edit-dialog-body">
                <div class="sbp-edit-form-group">
                    <label>模块名称 <span class="sbp-edit-required">*</span></label>
                    <el-input v-model.trim="newModuleName" placeholder="例如：行前安全教育" maxlength="50" show-word-limit />
                </div>
                <div class="sbp-edit-form-group">
                    <label>选择图标</label>
                    <div class="sbp-edit-icon-picker">
                        <div v-for="ic in iconOptions" :key="ic" class="sbp-edit-icon-option" :class="{ active: newModuleIcon === ic }"
                            @click="newModuleIcon = ic">{{ ic }}</div>
                    </div>
                </div>
                <div class="sbp-edit-form-group">
                    <label>上传文件</label>
                    <div class="sbp-edit-dialog-upload sbp-edit-upload-zone">
                        <upload ref="newModuleUpload" :key="'new-module-upload-' + addModuleUploadKey" zone @uploadFile="onNewModuleUploadFile"
                            @fileUploaded="onNewModuleFileUploaded" @fileDelete="onNewModuleFileDelete" name="newModuleFiles"
                            text="📁 点击上传文件（支持多选）" AdjustTheType="ReviewManagement" />
                    </div>
                </div>
                <div class="sbp-edit-form-group">
                    <label>模块描述（可选）</label>
                    <el-input v-model="newModuleDesc" type="textarea" :rows="3" placeholder="请输入模块描述..." maxlength="200" show-word-limit />
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="addModuleVisible = false">取 消</el-button>
                <el-button type="primary" :loading="addModuleSaving" @click="confirmAddModule">确认添加</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import {
        mapState
    } from 'vuex';
    import upload from './components/upload-file.vue';

    export default {
        name: 'SpaceBeforePrepEdit',
        components: {
            upload,
        },
        data() {
            return {
                prepDisplayName: '',
                modules: [],
                nextModuleId: 1,
                detailLoading: false,
                saveAllLoading: false,
                addModuleVisible: false,
                addModuleSaving: false,
                addModuleUploadKey: 0,
                newModuleName: '',
                newModuleIcon: '📜',
                newModuleDesc: '',
                newModuleUploadData: {
                    fileList: [],
                    fileMD5List: [],
                },
                /** 弹窗内首次上传时创建的区块 id，用于即时 bindSectionFiles */
                newModuleSectionId: null,
                newModuleBoundIds: [],
                /** identifier -> fileRelId（新增模块弹窗内已绑定文件） */
                newModuleFileRelMap: {},
                newModuleFileBinding: false,
                iconOptions: ['📜', '📦', '🏥', '📋', '🎒', '📚', '🛡️', '📝', '📎', '🎯', '🗂️', '📢'],
            };
        },
        computed: {
            ...mapState({
                currentProject: (state) => state.user.currentProject,
            }),
            isView() {
                return (this.$route.query.mode || 'edit') === 'view';
            },
        },
        watch: {
            '$route.query': {
                handler() {
                    this.hydrateFromRoute();
                },
                deep: true,
                immediate: true,
            },
            'currentProject.id'() {
                this.hydrateFromRoute();
            },
        },
        methods: {
            decodeRoutePrepName(prepName) {
                let name = prepName ? String(prepName) : '';
                if (!name) return '';
                try {
                    return decodeURIComponent(name.replace(/\+/g, ' '));
                } catch (e) {
                    return name;
                }
            },
            mapSectionToModule(section) {
                const files = Array.isArray(section.files) ? section.files : [];
                const mappedFiles = files
                    .filter((f) => f && f.fileIdentifier)
                    .map((f) => ({
                        name: f.fileName || '',
                        identifier: f.fileIdentifier,
                        fileRelId: f.id != null ? f.id : (f.fileRelId != null ? f.fileRelId : null),
                    }));
                const uploadList = mappedFiles.map((f) => ({
                    identifier: f.identifier,
                    filename: f.name,
                    fileRelId: f.fileRelId,
                }));
                return {
                    id: section.id,
                    icon: section.iconKey || '📜',
                    name: section.title || '',
                    desc: section.description || '',
                    files: mappedFiles,
                    uploadList,
                    boundFileIds: mappedFiles.map((f) => f.identifier).filter(Boolean),
                };
            },
            async bindSectionFilesToSection(sectionId, identifiers) {
                const ids = (identifiers || []).filter(Boolean);
                if (!ids.length) return true;
                const projectId = this.currentProject && this.currentProject.id;
                if (!projectId) {
                    this.$message.warning('未获取到项目信息');
                    return false;
                }
                try {
                    const res = await this.$Api.PrePrepare.bindSectionFiles({
                        sectionId: Number(sectionId),
                        projectId,
                        identifiers: ids,
                    });
                    return res;
                } catch (e) {
                    this.$message.error('绑定文件失败');
                    return null;
                }
            },
            mergeBindFileRelIds(mod, bindRes, identifiers) {
                if (!mod || !bindRes) return;
                const ids = (identifiers || []).filter(Boolean);
                const relList = bindRes.data;
                if (relList == null) return;
                const items = Array.isArray(relList) ? relList : [relList];
                items.forEach((rel) => {
                    const fileIdentifier = rel.fileIdentifier || rel.identifier;
                    const fileRelId = rel.id != null ? rel.id : rel.fileRelId;
                    if (fileRelId == null) return;
                    const file = (mod.files || []).find((f) => f.identifier === fileIdentifier || ids.includes(f.identifier));
                    if (file) {
                        file.fileRelId = fileRelId;
                    }
                });
                mod.uploadList = (mod.files || []).map((f) => ({
                    identifier: f.identifier,
                    filename: f.name,
                    fileRelId: f.fileRelId,
                }));
            },
            setUploadFileRelId(refKey, identifier, fileRelId) {
                const upload = this.getUploadRef(refKey);
                if (!upload || fileRelId == null) return;
                const idx = upload.fileMD5List.indexOf(identifier);
                if (idx >= 0 && upload.fileList[idx]) {
                    this.$set(upload.fileList[idx], 'fileRelId', fileRelId);
                }
            },
            async deleteSectionFileFromSection(fileRelId) {
                if (fileRelId == null || fileRelId === '') return true;
                const projectId = this.currentProject && this.currentProject.id;
                if (!projectId) {
                    this.$message.warning('未获取到项目信息');
                    return false;
                }
                try {
                    await this.$Api.PrePrepare.deleteSectionFile({
                        fileRelId: Number(fileRelId),
                        projectId,
                    });
                    return true;
                } catch (e) {
                    this.$message.error('删除文件失败');
                    return false;
                }
            },
            async fetchDetail() {
                const prepareId = this.$route.query.id;
                const projectId = this.currentProject && this.currentProject.id;
                if (!prepareId) {
                    this.modules = [];
                    return;
                }
                if (!projectId) {
                    this.modules = [];
                    return;
                }
                this.detailLoading = true;
                try {
                    const res = await this.$Api.PrePrepare.detail({
                        prepareId: Number(prepareId),
                        projectId,
                    });
                    const data = (res && res.data) || {};
                    this.prepDisplayName = data.name || this.prepDisplayName || '';
                    const sections = Array.isArray(data.sections) ? data.sections.slice() : [];
                    sections.sort((a, b) => (a.sortOrder || 0) - (b.sortOrder || 0));
                    this.modules = sections.map((s) => this.mapSectionToModule(s));
                    const maxId = sections.reduce((max, s) => Math.max(max, Number(s.id) || 0), 0);
                    this.nextModuleId = maxId > 0 ? maxId + 1 : 1;
                } catch (e) {
                    this.modules = [];
                    this.$message.error('获取详情失败');
                } finally {
                    this.detailLoading = false;
                }
            },
            hydrateFromRoute() {
                const {
                    id,
                    prepName
                } = this.$route.query;
                this.prepDisplayName = this.decodeRoutePrepName(prepName);
                if (!id) {
                    this.modules = [];
                    this.nextModuleId = 1;
                    return;
                }
                this.fetchDetail();
            },
            iconBg(icon) {
                const colorMap = {
                    '📜': '#fef0f0',
                    '📦': '#E8F4FD',
                    '🏥': '#f0f9eb',
                    '📋': '#ecf5ff',
                    '🎒': '#fdf6ec',
                    '📚': '#F5F3FF',
                    '🛡️': '#F4F4F5',
                    '📝': '#FDF2F8',
                    '📎': '#F0FDFA',
                    '🎯': '#FFF7ED',
                    '🗂️': '#F4F4F5',
                    '📢': '#fef0f0',
                };
                return colorMap[icon] || '#ecf5ff';
            },
            /**
             * 与 manager/components/upload-file 约定一致：多文件用 AdjustTheType=ReviewManagement
             */
            onModuleUploadFile(data) {
                const m = /^module_(\d+)$/.exec(data.name);
                if (!m) return;
                const mod = this.modules.find((x) => String(x.id) === m[1]);
                if (!mod) return;
                const fileList = data.fileList || [];
                const fileMD5List = data.fileMD5List || [];
                const oldByIdentifier = {};
                (mod.files || []).forEach((f) => {
                    if (f.identifier) oldByIdentifier[f.identifier] = f;
                });
                const nextFiles = fileList.map((f, i) => {
                    const identifier = fileMD5List[i];
                    const prev = oldByIdentifier[identifier] || {};
                    return {
                        name: f.name,
                        filemd5: f.filemd5,
                        identifier,
                        fileRelId: f.fileRelId != null ? f.fileRelId : (prev.fileRelId != null ? prev.fileRelId : null),
                    };
                });
                const nextUploadList = nextFiles.map((f) => ({
                    identifier: f.identifier,
                    filename: f.name,
                    fileRelId: f.fileRelId,
                }));
                const filesSame = JSON.stringify(mod.files || []) === JSON.stringify(nextFiles);
                const uploadSame = JSON.stringify(mod.uploadList || []) === JSON.stringify(nextUploadList);
                if (filesSame && uploadSame) return;
                mod.files = nextFiles;
                mod.uploadList = nextUploadList;
            },
            async onModuleFileUploaded(payload) {
                if (!payload || !payload.name) return;
                const m = /^module_(\d+)$/.exec(payload.name);
                if (!m) return;
                const sectionId = Number(m[1]);
                const identifier = payload.identifier;
                if (!identifier) return;
                const mod = this.modules.find((x) => Number(x.id) === sectionId);
                if (!mod) return;
                if (!mod.boundFileIds) {
                    this.$set(mod, 'boundFileIds', []);
                }
                if (mod.boundFileIds.includes(identifier)) return;
                const bindRes = await this.bindSectionFilesToSection(sectionId, [identifier]);
                if (!bindRes) return;
                mod.boundFileIds.push(identifier);
                this.mergeBindFileRelIds(mod, bindRes, [identifier]);
                const file = (mod.files || []).find((f) => f.identifier === identifier);
                if (file && file.fileRelId != null) {
                    this.setUploadFileRelId('moduleUpload' + sectionId, identifier, file.fileRelId);
                } else {
                    await this.fetchDetail();
                }
            },
            getUploadRef(refKey) {
                const ref = this.$refs[refKey];
                return Array.isArray(ref) ? ref[0] : ref;
            },
            removeFileFromUpload(refKey, index) {
                const upload = this.getUploadRef(refKey);
                if (upload && typeof upload.removeFileAt === 'function') {
                    upload.removeFileAt(index);
                }
            },
            async onModuleFileDelete(payload) {
                if (!payload || !payload.name) return;
                const m = /^module_(\d+)$/.exec(payload.name);
                if (!m) return;
                const sectionId = Number(m[1]);
                const identifier = payload.identifier;
                if (!identifier) return;
                const mod = this.modules.find((x) => Number(x.id) === sectionId);
                if (!mod) return;
                try {
                    await this.$confirm(`确认删除文件「${payload.fileName || ''}」？`, '提示', {
                        type: 'warning',
                    });
                } catch (e) {
                    return;
                }
                const fileRelId = payload.fileRelId != null ? payload.fileRelId : ((mod.files || []).find((f) => f.identifier === identifier) || {}).fileRelId;
                if (fileRelId != null && fileRelId !== '') {
                    const ok = await this.deleteSectionFileFromSection(fileRelId);
                    if (!ok) return;
                    mod.boundFileIds = (mod.boundFileIds || []).filter((id) => id !== identifier);
                }
                this.removeFileFromUpload('moduleUpload' + sectionId, payload.index);
                mod.files = (mod.files || []).filter((f) => f.identifier !== identifier);
                mod.uploadList = (mod.uploadList || []).filter((f) => f.identifier !== identifier);
            },
            async ensureNewModuleSection() {
                if (this.newModuleSectionId != null) {
                    return this.newModuleSectionId;
                }
                if (!this.newModuleName.trim()) {
                    this.$message.warning('请先填写模块名称后再上传文件');
                    return null;
                }
                const prepareId = this.$route.query.id;
                const projectId = this.currentProject && this.currentProject.id;
                if (!prepareId || !projectId) {
                    this.$message.warning('未获取到行前准备或项目信息');
                    return null;
                }
                const res = await this.$Api.PrePrepare.createSection({
                    prepareId: Number(prepareId),
                    projectId,
                    title: this.newModuleName.trim(),
                    iconKey: this.newModuleIcon,
                    description: (this.newModuleDesc || '').trim(),
                    sortOrder: this.modules.length,
                });
                if (res == null || res.data == null) {
                    this.$message.error((res && res.msg) || '创建模块失败，无法绑定文件');
                    return null;
                }
                this.newModuleSectionId = Number(res.data);
                return this.newModuleSectionId;
            },
            async bindNewModuleSectionFiles(identifiers) {
                const ids = (identifiers || []).filter(Boolean);
                if (!ids.length) return true;
                if (this.newModuleFileBinding) return false;
                this.newModuleFileBinding = true;
                try {
                    const sectionId = await this.ensureNewModuleSection();
                    if (sectionId == null) return false;
                    const bindRes = await this.bindSectionFilesToSection(sectionId, ids);
                    if (!bindRes) return false;
                    const mod = { files: [] };
                    ids.forEach((id) => {
                        if (!this.newModuleBoundIds.includes(id)) {
                            this.newModuleBoundIds.push(id);
                        }
                        mod.files.push({ identifier: id });
                    });
                    this.mergeBindFileRelIds(mod, bindRes, ids);
                    mod.files.forEach((f) => {
                        if (f.fileRelId != null) {
                            this.$set(this.newModuleFileRelMap, f.identifier, f.fileRelId);
                            this.setUploadFileRelId('newModuleUpload', f.identifier, f.fileRelId);
                        }
                    });
                    return true;
                } finally {
                    this.newModuleFileBinding = false;
                }
            },
            onNewModuleUploadFile(data) {
                if (data.name !== 'newModuleFiles') return;
                this.newModuleUploadData = {
                    fileList: data.fileList || [],
                    fileMD5List: (data.fileMD5List || []).filter(Boolean),
                };
            },
            async onNewModuleFileUploaded(payload) {
                if (!payload || payload.name !== 'newModuleFiles') return;
                const identifier = payload.identifier;
                if (!identifier || this.newModuleBoundIds.includes(identifier)) return;
                await this.bindNewModuleSectionFiles([identifier]);
            },
            async onNewModuleFileDelete(payload) {
                if (!payload || payload.name !== 'newModuleFiles') return;
                const identifier = payload.identifier;
                if (!identifier) return;
                try {
                    await this.$confirm(`确认删除文件「${payload.fileName || ''}」？`, '提示', {
                        type: 'warning',
                    });
                } catch (e) {
                    return;
                }
                const fileRelId = payload.fileRelId != null ? payload.fileRelId : this.newModuleFileRelMap[identifier];
                if (fileRelId != null && fileRelId !== '') {
                    const ok = await this.deleteSectionFileFromSection(fileRelId);
                    if (!ok) return;
                }
                this.newModuleBoundIds = this.newModuleBoundIds.filter((id) => id !== identifier);
                this.$delete(this.newModuleFileRelMap, identifier);
                this.removeFileFromUpload('newModuleUpload', payload.index);
            },
            // toggleEditName(mod) {
            //     this.$message.success(`可修改「${mod.name}」名称后点击保存`);
            // },
            deleteModule(mod) {
                const projectId = this.currentProject && this.currentProject.id;
                if (!mod || mod.id == null || !projectId) {
                    this.$message.warning('未获取到模块或项目信息');
                    return;
                }
                this.$confirm('确认删除此模块？该模块下的所有文件也将被删除。', '提示', {
                    type: 'warning',
                }).then(async () => {
                    try {
                        const res = await this.$Api.PrePrepare.deleteSection({
                            sectionId: Number(mod.id),
                            projectId,
                        });
                        this.$message.success('模块已删除');
                        await this.fetchDetail();
                    } catch (e) {
                        this.$message.error('删除模块失败');
                    }
                }).catch(() => {});
            },
            openAddModuleDialog() {
                this.addModuleUploadKey += 1;
                this.resetAddModuleForm();
                this.addModuleVisible = true;
            },
            resetAddModuleForm() {
                this.newModuleName = '';
                this.newModuleIcon = '📜';
                this.newModuleDesc = '';
                this.newModuleSectionId = null;
                this.newModuleBoundIds = [];
                this.newModuleFileRelMap = {};
                this.newModuleUploadData = {
                    fileList: [],
                    fileMD5List: [],
                };
            },
            async confirmAddModule() {
                if (!this.newModuleName) {
                    this.$message.warning('请输入模块名称');
                    return;
                }
                const prepareId = this.$route.query.id;
                const projectId = this.currentProject && this.currentProject.id;
                if (!prepareId || !projectId) {
                    this.$message.warning('未获取到行前准备或项目信息');
                    return;
                }
                const name = this.newModuleName;
                const ids = (this.newModuleUploadData.fileMD5List || []).filter(Boolean);
                const pendingBindIds = ids.filter((id) => !this.newModuleBoundIds.includes(id));
                this.addModuleSaving = true;
                try {
                    let sectionId = this.newModuleSectionId;
                    if (sectionId != null) {
                        const updateRes = await this.$Api.PrePrepare.updateSection({
                            sectionId,
                            projectId,
                            title: name,
                            iconKey: this.newModuleIcon,
                            description: (this.newModuleDesc || '').trim(),
                            sortOrder: this.modules.length,
                        });
                    } else {
                        const res = await this.$Api.PrePrepare.createSection({
                            prepareId: Number(prepareId),
                            projectId,
                            title: name,
                            iconKey: this.newModuleIcon,
                            description: (this.newModuleDesc || '').trim(),
                            sortOrder: this.modules.length,
                        });
                        sectionId = res && res.data;
                        if (sectionId == null) {
                            this.$message.error((res && res.msg) || '添加模块失败');
                            return;
                        }
                        sectionId = Number(sectionId);
                    }
                    if (pendingBindIds.length) {
                        await this.bindSectionFilesToSection(sectionId, pendingBindIds);
                    }
                    this.addModuleVisible = false;
                    this.$message.success(`模块「${name}」已添加`);
                    await this.fetchDetail();
                } catch (e) {
                    this.$message.error('添加模块失败');
                } finally {
                    this.addModuleSaving = false;
                }
            },
            async saveAll() {
                if (!this.prepDisplayName.trim()) {
                    this.$message.warning('请填写行前准备名称');
                    return;
                }
                const prepareId = this.$route.query.id;
                const projectId = this.currentProject && this.currentProject.id;
                if (!prepareId || !projectId) {
                    this.$message.warning('未获取到行前准备或项目信息');
                    return;
                }
                this.saveAllLoading = true;
                try {
                    await this.$Api.PrePrepare.batchSave({
                        prepareId: Number(prepareId),
                        projectId,
                        name: this.prepDisplayName.trim(),
                        sections: this.modules.map((m, index) => ({
                            id: m.id,
                            title: (m.name || '').trim(),
                            iconKey: m.icon || '📜',
                            description: (m.desc || '').trim(),
                            sortOrder: index,
                            fileIdentifiers: (m.files || []).map((f) => f.identifier).filter(Boolean),
                        })),
                    });
                    this.$message.success('所有配置已保存');
                    await this.fetchDetail();
                } catch (e) {
                    this.$message.error('保存失败');
                } finally {
                    this.saveAllLoading = false;
                }
            },
            goList() {
                this.$router.push({
                    path: '/home/spaceBeforePrep',
                });
            },
        },
    };
</script>

<style lang="less" scoped>
    @primary: #409eff;
    @primary-dark: #337ecc;
    @primary-light: #ecf5ff;
    @success: #67c23a;
    @success-bg: #f0f9eb;
    @warning: #e6a23c;
    @warning-bg: #fdf6ec;
    @danger: #f56c6c;
    @danger-bg: #fef0f0;
    @info: #909399;
    @info-bg: #f4f4f5;
    @bg: #f5f7fa;
    @text-primary: #303133;
    @text-regular: #606266;
    @text-secondary: #909399;
    @text-placeholder: #c0c4cc;
    @border: #dcdfe6;
    @border-light: #ebeef5;
    @shadow-light: 0 2px 12px rgba(0, 0, 0, 0.08);
    @shadow-base: 0 2px 8px rgba(0, 0, 0, 0.1);
    @radius: 8px;

    .sbp-edit {
        font-size: 14px;
        color: @text-primary;
        line-height: 1.5;
    }

    .sbp-edit-main-layout {
        max-width: 1400px;
        margin: 0 auto;
        padding: 16px 20px 40px;
    }

    .sbp-edit-project-name-bar {
        display: flex;
        align-items: center;
        gap: 12px;
        margin-bottom: 16px;
        padding: 2px 0 4px;
    }

    .sbp-edit-project-name-icon {
        width: 42px;
        height: 42px;
        border-radius: 10px;
        background: @primary-light;
        color: @primary;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-shrink: 0;
    }

    .sbp-edit-project-name-title {
        font-size: 18px;
        font-weight: 700;
        margin: 0;
        line-height: 1.45;
        flex: 1;
        min-width: 0;
    }

    .sbp-edit-panel {
        background: #fff;
        border-radius: @radius;
        box-shadow: @shadow-light;
        margin-bottom: 16px;
        overflow: hidden;
    }

    .sbp-edit-panel-header {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        gap: 12px;
        padding: 14px 16px;
        border-bottom: 1px solid @border-light;
    }

    .sbp-edit-panel-title {
        font-size: 15px;
        font-weight: 600;
        display: flex;
        align-items: center;
        gap: 8px;
    }

    .sbp-edit-panel-body {
        padding: 16px;
    }

    .sbp-edit-hint {
        font-size: 13px;
        color: @text-secondary;
        margin: 0 0 16px;
        line-height: 1.5;
    }

    .sbp-edit-form-group {
        margin-bottom: 16px;

        label {
            display: block;
            font-size: 13px;
            font-weight: 600;
            color: @text-primary;
            margin-bottom: 6px;
        }
    }

    .sbp-edit-required {
        color: @danger;
    }

    .sbp-edit-prep-name-field {
        max-width: 560px;
        margin-bottom: 20px;
    }

    .sbp-edit-form-input {
        width: 100%;
        padding: 8px 12px;
        border: 1px solid @border;
        border-radius: 6px;
        font-size: 13px;
        outline: none;
        box-sizing: border-box;
        transition: all 0.25s ease;

        &:focus {
            border-color: @primary;
            box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.15);
        }

        &:disabled {
            background: @bg;
            color: @text-secondary;
        }
    }

    .sbp-edit-empty {
        text-align: center;
        padding: 32px 20px;
        border: 1px dashed @border-light;
        border-radius: @radius;
        margin-bottom: 16px;
    }

    .sbp-edit-empty-icon {
        font-size: 40px;
        margin-bottom: 8px;
    }

    .sbp-edit-empty-text {
        font-size: 14px;
        color: @text-secondary;
        margin: 0;
    }

    .sbp-edit-module-card {
        border: 1px solid @border-light;
        border-radius: @radius;
        padding: 16px;
        margin-bottom: 12px;
        transition: all 0.25s ease;

        &:hover {
            box-shadow: @shadow-base;
        }

        &:last-child {
            margin-bottom: 0;
        }
    }

    .sbp-edit-module-card-header {
        display: flex;
        align-items: center;
        gap: 10px;
        margin-bottom: 10px;
    }

    .sbp-edit-module-card-icon {
        width: 36px;
        height: 36px;
        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 18px;
        flex-shrink: 0;
    }

    .sbp-edit-module-card-title {
        flex: 1;
        min-width: 0;
    }

    .sbp-edit-module-name-input {
        font-size: 14px;
        font-weight: 600;
        border: 1px solid transparent;
        background: transparent;
        padding: 2px 6px;
        border-radius: 4px;
        width: 100%;
        color: @text-primary;
        box-sizing: border-box;

        &:focus {
            border-color: @primary;
            background: #fff;
            outline: none;
        }

        &:disabled {
            color: @text-secondary;
        }
    }

    .sbp-edit-module-card-actions {
        display: flex;
        gap: 6px;
        flex-shrink: 0;
    }

    .sbp-edit-module-card-body {
        font-size: 12px;
        color: @text-secondary;
        margin-bottom: 8px;
    }

  /* 模块卡片 / 弹窗 — 上传区占满卡片宽度（样式见 upload-file zone 模式） */
    .sbp-edit-upload-zone {
        width: 100%;
    }

    .sbp-edit-module-upload.sbp-edit-upload-zone {
        margin-top: 10px;
    }

    .sbp-edit-dialog-upload.sbp-edit-upload-zone {
        margin-top: 0;

        /deep/ .upload-file--zone .file-list--zone {
            max-height: 200px;
            overflow-y: auto;
        }
    }

    .sbp-edit-panel-footer {
        padding: 16px;
        border-top: 1px solid @border-light;
        display: flex;
        align-items: center;
        gap: 12px;
        flex-wrap: wrap;
    }

    .sbp-edit-back-btn {
        margin-left: 0;
    }

    .sbp-edit-btn {
        display: inline-flex;
        align-items: center;
        gap: 5px;
        padding: 7px 14px;
        border-radius: 6px;
        font-size: 13px;
        font-weight: 500;
        cursor: pointer;
        border: 1px solid transparent;
        font-family: inherit;
        transition: all 0.25s ease;
    }

    .sbp-edit-btn-xs {
        padding: 3px 8px;
        font-size: 11px;
        border-radius: 4px;
    }

    .sbp-edit-btn-primary {
        background: @primary;
        color: #fff;
        border-color: @primary;

        &:hover {
            background: @primary-dark;
        }
    }

    .sbp-edit-btn-default {
        background: #fff;
        color: @text-regular;
        border-color: @border;

        &:hover {
            color: @primary;
            border-color: @primary;
            background: @primary-light;
        }
    }

    .sbp-edit-btn-danger {
        background: @danger;
        color: #fff;
        border-color: @danger;

        &:hover {
            background: #e05252;
        }
    }

    .sbp-edit-dialog-body {
        padding: 0 4px;
    }

    .sbp-edit-icon-picker {
        display: flex;
        gap: 8px;
        flex-wrap: wrap;
    }

    .sbp-edit-icon-option {
        width: 36px;
        height: 36px;
        border: 2px solid @border;
        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 18px;
        cursor: pointer;
        transition: all 0.25s ease;

        &:hover {
            border-color: @primary;
        }

        &.active {
            border-color: @primary;
            background: @primary-light;
        }
    }
</style>
